import { useSelector } from 'react-redux';

export const useSelectToken = () => useSelector(({ auth }) => auth?.token ?? '');
export const useSelectRole = () => useSelector(({ auth }) => auth?.role ?? []);
